export default "__VITE_ASSET__N7Q$hjC0__"